import React, { useEffect, useState, useRef } from 'react';
import { FormLabel, FormControlLabel, RadioGroup, Radio, Typography } from '@material-ui/core';
import DateInput from '../../Components/DateInput/DateInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import styles from './ReportDownloadContent.module.css';
import { CSVLink } from 'react-csv';
import { useDispatch, connect } from "react-redux";
import { showSnackbarAction } from '../../Redux/actions';
import { requestWhatsappBroadcastDetailedReport, requestWhatsappDispositionDetailedReport, fetchWhatsappDetailReportDropdown, fetchCampaignReportDateWise } from '../../Services/marketingAutomation';

interface ReportDownloadContentProps {
    setShowReportPopup: any,
    activeMarketTab: string,
    setSubmitReportRequest: any,
    submitReportRequest: any,
    user: any,
}

const ReportDownloadContent: React.FC<ReportDownloadContentProps> = ({ setShowReportPopup, activeMarketTab, setSubmitReportRequest, submitReportRequest, user }) => {

    const [campaignReport, setCampaignReport] = useState("detailed");
    // const [startDate, setStartDate] = useState("");
    // const [endDate, setEndDate] = useState("");
    // const [selectedDate, setSelectedDate] = useState("");
    const [selectedReport, setSelectedReport] = React.useState<string>("");
    const [dropdownValues, setDropdownValues] = useState([]);
    const [reportStartDate, setReportStartDate] = useState("");
    const [reportEndDate, setReportEndDate] = useState("");
    const [reportSelectedDate, setReportSelectedDate] = useState("");
    const [downloadHeaders, setDownloadHeaders] = useState([]);
    const [downloadData, setDownloadData] = useState([]);
    // const csvLinkRef:any = useRef(null);

    const dispatcher = useDispatch();

    const handleReportChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCampaignReport((event.target as HTMLInputElement).value);
    }

    const handleStartDateChange = (selectedDate: any) => {
        setReportStartDate(selectedDate);
    };

    const handleEndDateChange = (selectedDate: any) => {
        setReportEndDate(selectedDate);
    };

    const handleSelectedDateChange = (selectedDate: any) => {
        setReportSelectedDate(selectedDate);
    };

    const handleChange = (event: SelectChangeEvent) => {
        setSelectedReport(event.target.value as string);
    };

    const fetchDropdown = async() => {
        await fetchWhatsappDetailReportDropdown(activeMarketTab,reportStartDate,reportEndDate,reportSelectedDate,setDropdownValues);
    }

    const ReportSubmitionHandler = async (activeMarketTab: string) => {
        if (activeMarketTab === "Broadcast Message") {
            if (!reportStartDate) {
                dispatcher(showSnackbarAction(
                    "Start Date is required.",
                    "error"
                ))
                return;
            }
            if (!selectedReport) {
                dispatcher(showSnackbarAction(
                    "Please select a campaign to download.",
                    "error"
                ))
                return;
            }
            await requestWhatsappBroadcastDetailedReport(Number(selectedReport), Number(user.user_oid), dispatcher, setShowReportPopup, setReportStartDate, setReportEndDate);
            setSubmitReportRequest(!submitReportRequest);
        } else {
            if (!reportSelectedDate) {
                dispatcher(showSnackbarAction(
                    "Please select a date.",
                    "error"
                ))
                return;
            }
            if (!selectedReport) {
                dispatcher(showSnackbarAction(
                    "Please select a campaign to download.",
                    "error"
                ))
                return;
            }

            await requestWhatsappDispositionDetailedReport(Number(selectedReport), reportSelectedDate, Number(user.user_oid), dispatcher, setShowReportPopup, setReportSelectedDate);
            setSubmitReportRequest(!submitReportRequest);
        }
    }

    const OverviewReportSubmitionHandler = () => {
        if (!reportStartDate) {
            dispatcher(showSnackbarAction(
                "Start Date is required.",
                "error"
            ))
            return false;
        }
        setShowReportPopup(false);
        setReportStartDate("");
        setReportEndDate("");
        setReportSelectedDate("");
        document.body.classList.remove("no-overflow");
        return true;
    }

    useEffect(() => {
        setReportStartDate("");
        setReportEndDate("");
        setReportSelectedDate("");
    }, [])

    useEffect(()=>{
        fetchDropdown();
    },[reportStartDate,reportEndDate,reportSelectedDate])

    useEffect(() => {
        fetchCampaignReportDateWise(
            user.organization_id,
            reportStartDate,
            reportEndDate,
            setDownloadHeaders,
            setDownloadData,
            activeMarketTab
        );
        // setIsRefersh(false)
    }, [reportStartDate, reportEndDate, user.organization_id, activeMarketTab]);

    return (
        <div className={styles.ReportContentWrapper}>
            <div className={styles.ReportContentTitle}>Download Report</div>
            <div className={styles.ReportReportOpts}>
                <FormControl>
                    <FormLabel id="campaignReport" className={styles.ReportType}>Campaign Report</FormLabel>
                    <RadioGroup
                        aria-labelledby="campaignReport"
                        defaultValue="detailed"
                        name="radio-buttons-group"
                        className={styles.ReportTypeWrap}
                        value={campaignReport}
                        onChange={handleReportChange}
                    >
                        <FormControlLabel
                            value="detailed"
                            control={
                                <Radio style={{
                                    color: "rgb(39, 159, 159)",
                                    fontSize: "14px",
                                }} />
                            }
                            label="Detailed" />
                        <FormControlLabel
                            value="overview"
                            control={
                                <Radio style={{
                                    color: "rgb(39, 159, 159)",
                                    fontSize: "14px",
                                }} />
                            }
                            label="Overview" />
                    </RadioGroup>
                </FormControl>
            </div>
            <div className={styles.ReportDateRange}>
                {
                    (activeMarketTab === "Broadcast Message") &&
                    <>
                        <DateInput
                            mode="date"
                            onChange={handleStartDateChange}
                            value={reportStartDate}
                            label="Start Date *"
                            dateDisabled={false}
                        />
                        <DateInput
                            mode="date"
                            onChange={handleEndDateChange}
                            value={reportEndDate}
                            label="End Date"
                            dateDisabled={false}
                        />
                    </>
                }
                {
                    (activeMarketTab === "System Triggered Messages" && campaignReport === "overview") ?
                        <>
                            <DateInput
                                mode="date"
                                onChange={handleStartDateChange}
                                value={reportStartDate}
                                label="Start Date *"
                                dateDisabled={false}
                            />
                            <DateInput
                                mode="date"
                                onChange={handleEndDateChange}
                                value={reportEndDate}
                                label="End Date"
                                dateDisabled={false}
                            />
                        </>
                        :
                        (activeMarketTab === "System Triggered Messages" && campaignReport === "detailed") && (
                            <div style={{ width: "300px" }}>
                                <DateInput
                                    mode="date"
                                    onChange={handleSelectedDateChange}
                                    value={reportSelectedDate}
                                    label="Select Date *"
                                    dateDisabled={false}
                                />
                            </div>
                        )
                }
            </div>
            {
                campaignReport === "detailed" && (
                    <div className={styles.ReportSelection}>
                        <FormControl className={styles.ReportSelectionFc}>
                            <InputLabel id="selectcampaignReport">Select Campaign Report</InputLabel>
                            <Select
                                labelId="selectcampaignReport"
                                id="campaign-report"
                                value={selectedReport}
                                label="Campaign Report"
                                onChange={handleChange}
                                style={{
                                    color: "#303030",
                                    fontSize: "14px",
                                }}
                            >
                                {
                                    dropdownValues.map((item: any) => {
                                        return <MenuItem value={item.value}>{item.label}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </div>
                )
            }
            {
                campaignReport === "detailed" ?
                    <div className={styles.ReportSelectionActn}>
                        <span className={styles.ReportSelectionbtn} onClick={() => {
                            ReportSubmitionHandler(activeMarketTab);
                        }}>Submit</span>
                    </div>
                    :

                    (downloadData && downloadData.length > 0) ?
                        <div className={styles.ReportSelectionActn}>
                            <span className={styles.ReportSelectionbtn}>
                                <CSVLink  onClick={OverviewReportSubmitionHandler} data={downloadData} headers={downloadHeaders} filename={`WhatsappReport-${activeMarketTab}-${reportStartDate} To ${reportEndDate ? reportEndDate : "Today"}.csv`}>
                                    <span style={{ color: "#fff" }}>Download</span>
                                </CSVLink>
                                {/* <span style={{ color: "#fff" }}>Download</span> */}
                            </span>
                        </div> :
                        <div className={styles.ReportSelectionActn}>
                            <span className={styles.ReportSelectionbtn} onClick={() => {
                                if (!reportStartDate) {
                                    dispatcher(showSnackbarAction(
                                        "Start Date is required.",
                                        "error"
                                    ))
                                    return false;
                                }
                                dispatcher(showSnackbarAction(
                                    "No data available to download.",
                                    "warning"
                                ))
                            }}>
                                <span style={{ color: "#fff" }}>Download</span>
                            </span>
                        </div>

            }
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
    };
};

export default connect(mapStateToProps)(ReportDownloadContent);